import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class CommunicationChannelService {
    constructor(api) {
        this.api = api;
    }

    async getAll() {
        try {
            const response = await withRetry(() => this.api.getAll(), { maxRetries: 2 });
            return { success: true, data: response.data || [] };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch communication channels');
        }
    }

    async updatePolicy(channel, isEnabled) {
        try {
            const response = await this.api.update(channel, { isEnabled });
            return { success: true, data: response.data };
        } catch (error) {
            throw this._handleError(error, 'Failed to update communication channel policy');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
